export enum NBATeam {
    ATLANTA_HAWKS = "ATL Hawks",
    BOSTON_CELTICS = "BOS Celtics",
    BROOKLYN_NETS = "BKN Nets",
    CHARLOTTE_HORNETS = "CHA Hornets",
    CHICAGO_BULLS = "CHI Bulls",
    CLEVELAND_CAVALIERS = "CLE Cavaliers",
    DALLAS_MAVERICKS = "DAL Mavericks",
    DENVER_NUGGETS = "DEN Nuggets",
    DETROIT_PISTONS = "DET Pistons",
    GOLDEN_STATE_WARRIORS = "GS Warriors",
    HOUSTON_ROCKETS = "HOU Rockets",
    INDIANA_PACERS = "IND Pacers",
    LOS_ANGELES_CLIPPERS = "LA Clippers",
    LOS_ANGELES_LAKERS = "LA Lakers",
    MEMPHIS_GRIZZLIES = "MEM Grizzlies",
    MIAMI_HEAT = "MIA Heat",
    MILWAUKEE_BUCKS = "MIL Bucks",
    MINNESOTA_TIMBERWOLVES = "MIN Timberwolves",
    NEW_ORLEANS_PELICANS = "NO Pelicans",
    NEW_YORK_KNICKS = "NY Knicks",
    OKLAHOMA_CITY_THUNDER = "OKC Thunder",
    ORLANDO_MAGIC = "ORL Magic",
    PHILADELPHIA_76ERS = "PHI 76ers",
    PHOENIX_SUNS = "PHO Suns",
    PORTLAND_TRAIL_BLAZERS = "POR Trail Blazers",
    SACRAMENTO_KINGS = "SAC Kings",
    SAN_ANTONIO_SPURS = "SA Spurs",
    TORONTO_RAPTORS = "TOR Raptors",
    UTAH_JAZZ = "UTA Jazz",
    WASHINGTON_WIZARDS = "WAS Wizards",
}

export enum NBATeamColour {
    ATLANTA_HAWKS = "#E03A3E",
    BOSTON_CELTICS = "#007A33",
    BROOKLYN_NETS = "#000000",
    CHARLOTTE_HORNETS = "#1D1160",
    CHICAGO_BULLS = "#CE1141",
    CLEVELAND_CAVALIERS = "#860038",
    DALLAS_MAVERICKS = "#00538C",
    DENVER_NUGGETS = "#0E2240",
    DETROIT_PISTONS = "#C8102E",
    GOLDEN_STATE_WARRIORS = "#1D428A",
    HOUSTON_ROCKETS = "#CE1141",
    INDIANA_PACERS = "#002D62",
    LOS_ANGELES_CLIPPERS = "#C8102E",
    LOS_ANGELES_LAKERS = "#552583",
    MEMPHIS_GRIZZLIES = "#12173F",
    MIAMI_HEAT = "#98002E",
    MILWAUKEE_BUCKS = "#00471B",
    MINNESOTA_TIMBERWOLVES = "#0C2340",
    NEW_ORLEANS_PELICANS = "#C8102E",
    NEW_YORK_KNICKS = "#006BB6",
    OKLAHOMA_CITY_THUNDER = "#EF3B24",
    ORLANDO_MAGIC = "#0077C0",
    PHILADELPHIA_76ERS = "#006BB6",
    PHOENIX_SUNS = "#E56020",
    PORTLAND_TRAIL_BLAZERS = "#E03A3E",
    SACRAMENTO_KINGS = "#5A2D81",
    SAN_ANTONIO_SPURS = "#000000",
    TORONTO_RAPTORS = "#CE1141",
    UTAH_JAZZ = "#00471B",
    WASHINGTON_WIZARDS = "#002B5C",
}
